// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
import { ImageRatio } from '../_contracts';
import { BootstrapImage, BootstrapLink } from '../../dsl/front';
import { ModuleHeaderUi } from '../_components/ui';
import { prepareImage } from '../_filters';
import { AuthorInfoSidebar } from './_partials/AuthorInfoSidebar.ui';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
let EditorialOfficeModuleUi = class EditorialOfficeModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        //
        /**
         * Resolved authors list
         */
        this.authors = [];
        /**
         * @inheritDoc
         */
        this.imageRatios = {
            desktop: ImageRatio.Square,
            mobile: ImageRatio.Square
        };
    }
    async fetchRelated() {
        const authorsToResolve = Array.isArray(this.module.content.authors) ? this.module.content.authors : [];
        try {
            await Promise.all(authorsToResolve.map((authorToResolve) => {
                return new Promise((resolve, reject) => {
                    this.resolveAuthor(authorToResolve).catch((e) => {
                        reject(e);
                    });
                    return resolve();
                });
            }));
        }
        catch (e) {
        }
    }
    async resolveAuthor(authorToResolve) {
        const author = await this.relatedService.resolve(authorToResolve);
        const preparedAuthor = {
            ...author,
            avatar: prepareImage(author.avatar, this.imageRatio, 510, this.module.isLazyLoaded)
        };
        this.authors = [...this.authors, preparedAuthor];
    }
};
EditorialOfficeModuleUi = __decorate([
    Component({
        name: 'EditorialOfficeModuleUi',
        components: {
            AuthorInfoSidebar,
            BootstrapImage,
            BootstrapLink,
            ModuleHeaderUi
        },
        async created() {
            await this.fetchRelated();
        },
        template: `
    <section class="editorial-office-module">

    <!--Sidebar has been removed-->

    <!--<AuthorInfoSidebar-->
    <!--  v-if="sidebarOpen"-->
    <!--  :author="selectedAuthor"-->
    <!--  @sidebar-open="openWithAuthor"-->
    <!--  @sidebar-close="close"/>-->

      <!-- TMP -->
      <div class="container">
        <div class="row">
          <div class="col">
            <ModuleHeaderUi :header="module.content.header" />
          </div>
        </div>
        <div class="row">
          <!-- Authors -->
          <div class="col editorial-office-module__authors">
            <!-- Author -->
            <div v-if="authors.length > 0" v-for="author in authors" class="editorial-office-module__author-tile">
              <template v-if="author.url">
                <BootstrapLink :link="{ target: author.url }" class="text-decoration-none">
                  <BootstrapImage v-bind="author.avatar"/>
                </BootstrapLink>
                  <div class="text-center">
                    <p>{{author.title}} {{author.firstName}} {{author.lastName}}</p>
                    <small v-if="author.position" class="text-uppercase">{{author.position}}</small>
                  </div>
              </template>
              <template v-else>
                <BootstrapImage v-bind="author.avatar"/>
                <div class="text-center">
                  <p>{{author.title}} {{author.firstName}} {{author.lastName}}</p>
                  <small v-if="author.position" class="text-uppercase">{{author.position}}</small>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- END | TMP -->
    </section>
  `
    })
], EditorialOfficeModuleUi);
export { EditorialOfficeModuleUi };
